var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntruder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FEC70B;}\r\n\t.st1{fill:#FEC504;}\r\n\t.st2{fill:#FECC22;}\r\n\t.st3{fill:#FECD25;}\r\n\t.st4{fill:#FECC20;}\r\n\t.st5{fill:#FECC24;}\r\n\t.st6{fill:#FECA1A;}\r\n\t.st7{fill:#FEC400;}\r\n\t.st8{fill:#FED446;}\r\n\t.st9{fill:#FEFBF1;}\r\n\t.st10{fill:#FEF6DB;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Intruder"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.4,23.8l-6.1,0.3c-0.8,0.2-1.6-0.3-1.8-1.1c0-0.2,0-0.4,0-0.6c0-1.3,0.4-1.9,1.8-2.1 C78.6,19.5,80.1,20.4,80.4,23.8L80.4,23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50,23.9c-0.4-1.3-1.1-3,0.8-3.4c2-0.6,4.1-0.5,6,0.3c0.4,0.2,0.4,1.2,0.5,1.8c0,1.1-0.7,1.4-1.6,1.4 c-1.9,0-3.8-0.1-5.7-0.2L50,23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.9,65.6c0.8,0.1,1.6,0.2,2.4,0.3c1.5,0,1.7,1,1.7,2.2S45.6,70,44.4,70c-1.2,0-2.6,0.2-2.4-1.3 c0.3-2.9-2.4-1.7-3.4-2.9C39.4,64.8,40.9,64.8,41.9,65.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M91.3,65.7c-1,1-3.6-0.2-3.4,2.5c0.1,1.7-1.2,1.7-2.4,1.7s-1.6-0.7-1.6-1.8c0-1.4,0.4-2.3,2-2.3 c0.7,0,1.3-0.1,2-0.1c0.9-0.9,2.4-1,3.3-0.1C91.2,65.6,91.2,65.7,91.3,65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M68.9,58.3h1.2c1.6,0,3,0,2.9,2.2c0,1.4-0.7,1.8-2,1.9c-2.3,0.1-2.2-1.4-2.1-2.9 C68.8,59.1,68.9,58.7,68.9,58.3L68.9,58.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M91.3,65.7h-3.4v-3.3l-0.1,0.1C90.4,61.9,93,61.5,91.3,65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M41.9,65.6h-3.3c-1.1-3.3,0.5-3.8,3.2-3.2h-0.1C42.1,63.4,42.2,64.6,41.9,65.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M49.9,23.8L49.9,23.8L49.9,23.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M41.8,62.4L41.8,62.4l-0.1-0.1L41.8,62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M87.8,62.4L87.8,62.4L87.8,62.4L87.8,62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M68.9,58.3L68.9,58.3L68.9,58.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M80.3,23.9L80.3,23.9L80.3,23.9L80.3,23.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M84.3,53.8c-0.2,0-0.3-0.7-0.3-1.1c0-3.9,0-7.9,0-11.9c0-0.4,0.5-1.2,0.8-1.2c4.2,0,3-3,3-5.2 c0-2.8,1.3-5.9-3.1-7.5c-0.9-0.3-1.9-3.1-4.3-3c0,2,0,4,0,6c0.1,0.8-0.5,1.5-1.3,1.5c-0.1,0-0.1,0-0.2,0c-0.8,0-2,0.1-2.1-0.8 c-0.2-4.1-3.2-2.8-5.3-2.8c-5-0.1-10.1,0-15.1,0c-1.5,0-3.1-0.3-3,2.1c0,1.5-0.9,1.7-2.2,1.7s-1.4-1.1-1.4-2.1 c0-1.9,0.1-3.8,0.2-5.6c-4.4-1.2-4.6,4.2-7.8,5.3c-1,0.3-0.3,5.6-0.2,8.6c0,2.2,1.9,1.3,3.1,1.7c1.1,0.4,0.8,1.6,0.8,2.5 c0,2.6,0,5.2,0,7.8c0,2.1,1,4.8-2.8,5c-1.2,0-0.9,1.5-1,2.4c-0.1,1.7-0.1,3.4-0.2,5.2c0.5-0.1,1-0.1,1.5,0c2.3,0.5,6-1.8,6.5,3 c0.1,1.2,2.1,1.1,3.1,0.3c1.5-1.2,0.3-6.8-1.6-7.4s-1.8-1.9-1.2-3.1c0.7-1.2,6.9-0.6,6.9,1c0.2,2.7,2,2,3.4,2.1 c0-4.7,0.3-4.8,4.1-3.3l0,0c1.2,0.9,0.7,2.2,0.8,3.3h3.3c0.3-1.3-0.8-3.3,1.6-3.4c2.7-0.2,5.5,0,8.2,0c0.9,0,1.6,0.4,1.6,1.4 s0.2,2-0.9,2c-4.9,0.1-2.5,3.8-3,5.9c-0.3,1.3,0.4,2.1,1.8,2.1c1.4,0,2.2-0.3,2.1-1.7c-0.2-2,1.1-2.2,2.6-2.1 c1.5,0.1,3.2,0,4.8,0.1C87.2,59.3,90.2,54.8,84.3,53.8z M60.5,46.1c-1.4,1.7-3.4,0.6-5.3,0.8c-1.4,0.2-1.7-0.8-1.9-2 c-0.6-4.7,0-5.5,4-5.4l0,0l0,0c0-0.1,0-0.2,0-0.3c0.2-1.4-0.9-3.6,1.9-3.6c1.3,0,1.5,0.9,1.6,1.9c0,2.7-1.9,1.9-3.4,2l0,0l0,0 c0.1,1.7-0.8,3.9,2.3,4.1C61.2,43.6,61,45.4,60.5,46.1z M70.5,35.5c1.3-0.1,2.1,0.4,2.2,1.7c0.1,1.3-0.2,2.1-1.7,2.2 s-2.1-0.3-2.1-1.7C68.8,36.4,68.9,35.4,70.5,35.5z M69.6,46.9c-0.9-0.5-1.1-1.8-0.7-2c2.4-1.3,3.4-3.8,5.5-5.3 c0.6-0.3,1.4-0.1,1.7,0.5c0.1,0.1,0.1,0.3,0.1,0.4c0.1,0.7,0.1,1.4,0.1,2.1c0.1,2.5-1.9,4.6-4.4,4.7 C71.2,47.4,70.4,47.2,69.6,46.9L69.6,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M62.9,58.2c-0.7,0.1-1.3-0.4-1.4-1.1c0,0,0,0,0-0.1c-0.1,0.6-0.4,1-0.9,1.4c0,2.3-0.2,5,3.4,3.9 c1.7-0.6,0.5-2.7,1.4-3.9c-0.4-0.4-0.7-0.9-0.9-1.5C64.6,57.6,64.3,58.2,62.9,58.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M61.5,57c0-0.1,0-0.2,0-0.4c0-2.5,2-1.5,3.3-1.6c-3.8-1.5-4-1.3-4.1,3.3C61.1,58,61.4,57.5,61.5,57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M64.8,55c0,0.1,0,0.3,0,0.4c0,0.5,0,1,0,1.4c0.2,0.6,0.5,1.1,0.9,1.5C65.4,57.2,66,55.9,64.8,55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M57.4,39.4L57.4,39.4L57.4,39.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "57.4,39.4 57.4,39.4 57.4,39.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "57.4,39.4 57.4,39.4 57.4,39.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M57.4,39.4L57.4,39.4L57.4,39.4L57.4,39.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "57.4,39.4 57.4,39.4 57.4,39.4 57.4,39.5  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntruder);
export default __webpack_public_path__ + "static/media/Intruder.c7a5267fb787da3509aa473e8a88d7d8.svg";
export { ForwardRef as ReactComponent };